<div class="teaser bg-lightest mb-0">
  <div class="d-flex justify-content-between align-items-center gap-3">
    <div class="d-flex align-items-center gap-2">
      <i
        class="fa-solid fs-4 me-2"
        [ngClass]="
          documentInfo?.type === baseFileExtension.pdf ||
          documentToUploadInfo?.file?.type === baseFileExtension.pdf ||
          documentToUploadInfo?.file?.type === baseMimeType.pdf
            ? 'fa-file-pdf'
            : 'fa-file-image'
        "
      ></i>
      <span
        class="fw-bold"
        baseTruncate
        >{{ (isExistingDocument ? documentInfo?.name : documentToUploadInfo?.name) | baseIsEmpty }}</span
      >
    </div>
    <div class="d-flex align-items-center justify-content-end gap-2">
      <base-button
        *ngIf="!canDeleteDocument"
        color="dark"
        icon="fa-solid fa-download"
        stateClass="pe-1"
        [iconSize]="buttonSize.md"
        (btnClick)="downloadDocument()"
      ></base-button>
      <base-button
        color="dark"
        icon="fa-solid fa-eye"
        stateClass="pe-1"
        [iconSize]="buttonSize.md"
        (btnClick)="downloadDocument(true)"
      ></base-button>
      <base-button
        *ngIf="canDeleteDocument"
        color="dark"
        icon="fa-solid fa-trash"
        stateClass="pe-1"
        [iconSize]="buttonSize.md"
        (btnClick)="openDeleteDocumentModal()"
      ></base-button>
    </div>
  </div>
</div>

<ng-template #documentViewerTemplate>
  <base-document-viewer
    *ngIf="documentInfo || documentToUploadInfo"
    [src]="activeDocumentSrc"
    [fileName]="documentFileName"
    [fileType]="documentFileType"
    [modalRef]="documentViewerModalRef"
    (downloadImage)="downloadDocument()"
  ></base-document-viewer>
</ng-template>

<ng-template #deleteDocumentModalTemplate>
  <base-delete-document-confirmation-template
    [documentName]="documentInfo?.name || ''"
  ></base-delete-document-confirmation-template>
</ng-template>
